import React from 'react';
import { useForm } from 'react-hook-form';
import { footerContact, footerContactNum, navLinks } from '../constants';

// import { Link } from 'react-router-dom'
import { FaAngleRight, FaArrowRight, FaEnvelope, FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube  } from 'react-icons/fa';
import { AiFillYoutube } from 'react-icons/ai';
import { NavLink } from 'react-router-dom';

const Footer = () => {
    const {
        register, 
        formState: {errors}, 
        handleSubmit
      } = useForm({
        mode: "all",
      });

  return (
    <footer>
        <div className="col first-col">
            <h1><span style={{fontFamily: 'Gabriola',color: '#ab0303',size:"55px"}}>Little Sanctum</span></h1>   
            <p>An Authentic AMI Montessori school</p>
        </div>
        <div className="col second-col">
            <h2>Links</h2>
            {navLinks.map(link => (
                <ul key={link.id}>
                    <li><FaAngleRight /> <NavLink to={link.link} key={link.id} className="link">{link.id}</NavLink></li>
                </ul>    
            ))}
        </div>
        <div className="col third-col">
            <h2>Contact us</h2>
            {footerContact.map(contact => (
                <ul key={contact.id}>
                    <li>{contact.text}</li>
                </ul>
            ))}
            <div className="contNum">
                {footerContactNum.map(msg => (
                    <ul key={msg.id}>
                        <li><div className="icon">{msg.icon}</div>{msg.text}</li>
                    </ul>
                ))}
            </div>
        </div>
        <div className="col fourth-col">
            <h2>Follow us</h2>
            
            <p style={{color: "red",}}>{errors.email?.message}</p>
            <div className="icons">
                <NavLink to='https://www.youtube.com/channel/UCvuInT7f2s3rSuqYGYeRbIg' style={{ color: '#fff' }}><AiFillYoutube size={60}/></NavLink>
                <NavLink to='https://www.instagram.com/littlesanctummontessori/' style={{ color: '#fff' }}><FaInstagram size={60}/></NavLink>
                <NavLink to='https://www.facebook.com/share/1CUEkJgeNE/' style={{ color: '#fff' }}><FaFacebook size={60}/></NavLink>
                <NavLink to='https://www.linkedin.com/company/little-sanctum-montessori/' style={{ color: '#fff' }}><FaLinkedin size={60}/></NavLink>
                
                
                </div>
        </div>
        
        
    </footer>
  )
}

export default Footer